var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBroadcastCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  clipPath: "url(#broadcastCamera_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m38.438 38.438-9.553-7.26v-8.024l9.553-7.26zm-36.875 0h27.321V15.895H1.562zm6.513-31.25c2.84-3.434 7.13-5.625 11.924-5.625s9.084 2.191 11.923 5.625M15.17 10.037A9.16 9.16 0 0 1 20 8.668c1.769 0 3.424.501 4.829 1.37"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "broadcastCamera_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default SvgBroadcastCamera;